module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tvChannels":"TV channels"}}')
  delete Component.options._Ctor
}
